import React, { ReactNode } from 'react';

function TcPaper({
    classNameStyle = "",
    children
}: {
    readonly classNameStyle?: string;
    readonly children: ReactNode
}) {
    return (
        <div className={`relative px-8 pt-0 pb-4 2xs-landscape:pt-0 xs-landscape:pt-0 mx-auto max-w-4xl w-full h-auto ${classNameStyle}`}>
            {children}
        </div>
    )
}

export default TcPaper;